var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeth25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 70,
    viewBox: "0 0 48 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2777_3299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7134 60.0473C41.6629 59.1901 43.6293 48.9034 43.6293 36.0451C44.6125 23.1868 39.6966 -1.6727 24.9489 0.898969C13.1507 2.61341 6.26844 18.0434 5.28526 33.4734C3.3189 48.9034 5.28525 59.1901 8.23479 60.9045C12.1675 61.7618 34.7807 61.7618 38.7134 60.0473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6734 59.9557L38.6731 59.9549L38.6855 59.9513C39.3778 59.7501 40.0376 58.9839 40.6352 57.7013C41.2296 56.4256 41.75 54.6663 42.1794 52.5269C43.038 48.2493 43.5293 42.47 43.5293 36.0451H43.529L43.5296 36.0375C44.0202 29.6212 43.0384 20.2072 40.0951 12.7224C38.6235 8.98004 36.6647 5.72837 34.1624 3.5732C31.6634 1.42096 28.6207 0.360197 24.966 0.997522L24.9632 0.99793C19.107 1.84893 14.459 6.10549 11.149 12.0913C7.83942 18.0761 5.87593 25.776 5.38506 33.4798L5.38526 33.4798L5.38446 33.4861C4.40207 41.1948 4.40261 47.6152 5.01572 52.3194C5.32232 54.6718 5.7817 56.5919 6.34614 58.0284C6.90857 59.4598 7.56908 60.3949 8.27156 60.8102C9.25149 61.0206 11.3848 61.1801 14.1066 61.2734C16.8392 61.3671 20.1557 61.3939 23.4725 61.3403C26.7894 61.2868 30.1053 61.1529 32.8367 60.9254C34.2025 60.8117 35.4211 60.6747 36.42 60.5128C37.4211 60.3506 38.1941 60.1646 38.6734 59.9557Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2777_3299",
    x: 0.492188,
    y: 0.713867,
    width: 47.2578,
    height: 68.7539,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2777_3299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2777_3299",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth25);
export default __webpack_public_path__ + "static/media/teeth25.d4e98fdb5bc03c44178cd1e8c9c144e2.svg";
export { ForwardRef as ReactComponent };